// index.js
import RecentMembersSection from './container';

export default RecentMembersSection;
